import "moment-timezone";
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import NoSaleForm from './NoSaleForm';

class NoSaleModal extends Component {
  render() {
    const { deal, noSaleType, showModal, onConfirmModal, onCloseModal } = this.props
    const title = noSaleType === 'no_sale' ? "No Sale" : "Dead Deal"

    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <NoSaleForm deal={deal} noSaleType={noSaleType} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default NoSaleModal